module.exports = __webpack_public_path__ + "img/sun.48823c56.svg";